import { ISystemAiFunction } from 'app/shared/model/system-ai-function.model';

export interface ISystemAiPrompt {
  id?: number;
  promptText?: string;
  type?: string;
  systemAiFunction?: ISystemAiFunction | null;
}

export const defaultValue: Readonly<ISystemAiPrompt> = {};
